var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Route } from 'react-router-dom';
import ModalRouteContent from './ModalRouteContent';
import propTypes from 'prop-types';

function ModalRoute(_ref) {
  var defaultParentPath = _ref.defaultParentPath,
      component = _ref.component,
      rest = _objectWithoutProperties(_ref, ['defaultParentPath', 'component']);

  return React.createElement(Route, _extends({}, rest, {
    render: function render(props) {
      return React.createElement(
        ModalRouteContent,
        _extends({}, props, { defaultParentPath: defaultParentPath }),
        component
      );
    }
  }));
}

ModalRoute.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Route.propTypes, {
  defaultParentPath: propTypes.string.isRequired
}) : {};

export default ModalRoute;